module.exports = __webpack_public_path__ + "img/car-rental.5fe3ee0e.png";